export default __webpack_public_path__ + "static/media/terms_and_conditions.61a006c6.pdf";